import React from 'react'

interface Props {
  children: React.ReactNode
}

const CardHeading: React.FC<Props> = ({ children }) => (
  <div className="mb-1 font-bold text-black">{children}</div>
)

export default CardHeading
